/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * Tax support version0 = None

1 = V1


 */
export type JobTaxVersion = (typeof JobTaxVersion)[keyof typeof JobTaxVersion];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobTaxVersion = {
  None: 0,
  V1: 1,
} as const;
